import { KpiSummary, SalesAttribution, TopItems, Adjustments, Leaderboard } from 'model/salesDashboard';

export enum SalesDashboardStatus {
    Initial,
    Error,
    Fetching,
    FetchSuccess
}

export interface SalesDashboardState {
    status: SalesDashboardStatus;
    error?: string;
    loadingKpiSummary: boolean;
    loadingSalesAttribution: boolean;
    loadingTopItems: boolean;
    loadingAdjustments: boolean;
    loadingLeaderboard: boolean;
    kpiSummary?: KpiSummary;
    salesAttribution?: SalesAttribution;
    topItems?: TopItems;
    adjustments?: Adjustments;
    leaderboard?: Leaderboard;
    filters: import('model/salesDashboard').SalesDashboardFilters;
}
